import { useState } from 'react';
import styles from './index.module.scss';
import userAvatarPlaceholder from '@/assets/icons/user/avatar.svg?url';

interface IUserAvatarProps {
  src?: string;
  size?: number;
  className?: string;
}

export const UserAvatar = (props: IUserAvatarProps) => {
  const { src, size = 200, className = '' } = props;
  const [isError, setIsError] = useState(false);
  const onError = () => {
    setIsError(true);
  };
  return (
    <div className={`${styles.root} ${className}`} style={{ '--avatar-size': `${size}px` } as React.CSSProperties}>
      {src?.length && !isError ? (
        <img className={styles.image} src={src} onError={onError} />
      ) : (
        <img src={userAvatarPlaceholder} className={styles.placeholder} alt="avatar" />
      )}
    </div>
  );
};
